import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

import { useTeams } from "@/Hooks/UseTeam";
import useTranslation from "../../Hooks/UseTranslation";

import InputFormControl from "../InputFormControl/InputFormControl";

type Props = {
  onHide?: any;
};

const TeamCreator = (props: Props) => {

  const { onHide } = props;

  const { t } = useTranslation();

  const { createTeam, showTeamCreator, setShowTeamCreator } = useTeams()

  const [ name, setName ] = useState('')

  const handleSaveTeam = async () => {

    await createTeam(name)

    setName('')

    setShowTeamCreator(false)
    onHide && onHide()
  }

  const cancel = () => {
    setName('')

    setShowTeamCreator(false)

    onHide && onHide()
  };

  return (
    <Modal
      show={showTeamCreator}
      onHide={onHide}
      backdrop="static"
      keyboard={true}
    >
      <Modal.Header>
        <Modal.Title>
          {t('TEAM_CREATOR:Title')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group row">
          <label htmlFor="" className="col-sm-3 col-form-label">
            {t('TEAM_CREATOR:InputNameLabel')}
          </label>
          <div className="col-sm-9">
            <InputFormControl
              autoFocus={true}
              value={name}
              onChange={setName}
              onEnter={handleSaveTeam}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-secondary" onClick={() => cancel()}>
          <span className="icon-cancelar"></span> {t('TEAM_CREATOR:CancelButton')}
        </button>
        <button
          className="btn btn-primary active"
          onClick={handleSaveTeam}
          disabled={name === ""}>
          <span className="icon-guardar"></span> {t('TEAM_CREATOR:CreateButton')}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TeamCreator;
